import { render, staticRenderFns } from "./comp_ProductCard-EcomodicoVariantSelector.vue?vue&type=template&id=5eeaf4b8&scoped=true"
import script from "./comp_ProductCard-EcomodicoVariantSelector.vue?vue&type=script&lang=js"
export * from "./comp_ProductCard-EcomodicoVariantSelector.vue?vue&type=script&lang=js"
import style0 from "./comp_ProductCard-EcomodicoVariantSelector.vue?vue&type=style&index=0&id=5eeaf4b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eeaf4b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
